import { ListItemLabel } from "baseui/list";
import { ValueDisplay } from "../../components/ValueDisplay";
import { ICO2Rate } from "./types";
import { MdCo2 } from "react-icons/md";
import { SelectableListItem } from "../../../components/SelectableListItem";
import { useStyletron } from "baseui";

interface SelectabeCO2RateProps extends ICO2Rate {
    isSelected?: boolean
    onSelect?: (item: ICO2Rate) => void,
    canDelete?: boolean,
    canEdit?: boolean

}
const SelectableCO2RateListItem = (props: SelectabeCO2RateProps) => {
    const [css,theme] = useStyletron();
    return (
        <SelectableListItem
            key={props.id}
            item={props}
            onSelect={props.onSelect}
            isSelected={props.isSelected}
            artwork={() => <MdCo2 color={theme.colors.positive400} size={'2em'}></MdCo2>}
            artworkSize={'LARGE'}
            endEnhancer={() => (
                <>
                    <ValueDisplay small value={props.valuePerUnit} dimension="kg/Unit"></ValueDisplay>
                </>
            )}        >
            <ListItemLabel>{props.name}</ListItemLabel>
        </SelectableListItem>
    )
}

export default SelectableCO2RateListItem;